export const cartInitialState = JSON.parse(window.localStorage.getItem('cartJetImpresiones')) || []

export const CART_ACTION_TYPES = {
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  CLEAR_CART: 'CLEAR_CART'
}

export const updateLocalStorage = state => {
  window.localStorage.setItem('cartJetImpresiones', JSON.stringify(state))
}

const UPDATE_STATE_BY_ACTION = {
  [ CART_ACTION_TYPES.ADD_TO_CART ]: (state, action) => {
    const { id, set, selectedColor } = action.payload
    const productInCartIndex = state.findIndex(item => item.id === id && item.selectedColor === selectedColor)

    if (productInCartIndex >= 0) {
      const newState = [
        ...state.slice(0, productInCartIndex),
        {
          ...state[ productInCartIndex ],
          quantity: set ? action.payload.quantity : state[ productInCartIndex ].quantity + action.payload.quantity
        },
        ...state.slice(productInCartIndex + 1)
      ]
      updateLocalStorage(newState)
      return newState
    }

    const newState = [
      ...state,
      {
        ...action.payload
      }
    ]
    updateLocalStorage(newState)
    return newState
  },
  [ CART_ACTION_TYPES.REMOVE_FROM_CART ]: (state, action) => {
    const { id, selectedColor } = action.payload
    const newState = state.filter(item => !(item.id === id && item.selectedColor.name === selectedColor.name))
    updateLocalStorage(newState)
    return newState
  },
  [ CART_ACTION_TYPES.CLEAR_CART ]: () => {
    updateLocalStorage([])
    return []
  }
}

export const cartReducer = (state, action) => {
  const { type: actionType } = action
  const updateState = UPDATE_STATE_BY_ACTION[ actionType ]
  return updateState ? updateState(state, action) : state
}
